import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';

import { LoaderEvent } from './../../shared/message.event';
import { UtilityFunctions } from '../../shared/utility-functions';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { Invoice } from '../../primecalendar/Invoice';
@Component({
	selector: 'manual-invoice',
	templateUrl: './manual-invoice.component.html',
	styleUrls: ['./manual-invoice.component.css'],
	providers: [],
	exportAs: 'manualInvoice'
})
export class ManualInvoice {
	constructor() {
	}
	@Output() sendInvoice = new EventEmitter<boolean>();
	private utilityFunctions = new UtilityFunctions();
	private showManualInvoice = {
		invoiceIdToShow: '',
		subject: '',
		description: '',
		date: '',
		time: '',
		link: '',
		amount: '',
		sendTo: 'All'
	};
	@ViewChild('childModal') childModal: ModalDirective;
	public showChildModal(invoiceToShow, sendTo): void {
		this.childModal.config.backdrop = false;
		this.childModal.config.keyboard = false;
		this.utilityFunctions.setBackGroundBlack();
		this.setValues(invoiceToShow, sendTo);
		this.childModal.show();
	}

	public hideChildModal(): void {
		this.utilityFunctions.removeBackGroundBlack();
		this.childModal.hide();
	}

	setValues(invoiceToShow: any, sendTo: string) {
		this.showManualInvoice.invoiceIdToShow = invoiceToShow.invoiceIdToShow;
		this.showManualInvoice.subject = invoiceToShow.subject;
		this.showManualInvoice.description = invoiceToShow.description;
		this.showManualInvoice.amount = invoiceToShow.totalAmount;
		this.showManualInvoice.link = invoiceToShow.panaltyLink;
		this.showManualInvoice.sendTo = sendTo;
		this.showManualInvoice.date = this.utilityFunctions.maketimeZoneOfsetDate(invoiceToShow.createdAt).format('dddd, LL');
		this.showManualInvoice.time = this.utilityFunctions.maketimeZoneOfsetDate(invoiceToShow.createdAt).format('HH:mm');
	}

	sendInvoiceToMember() {
		this.sendInvoice.emit(true);
		this.hideChildModal();
	}
}


// WEBPACK FOOTER //
// ./src/app/account/manual-invoice/manual-invoice.component.ts